import type { AuthChangedEvent } from '@ixigo-packages/login/core';

/**
 * A loader-relevant auth change is one where the login STATUS flips
 * (anonymous ⇄ authenticated, or resolving → settled). The SDK store also emits
 * `auth-changed` when only the user OBJECT hydrates lazily — i.e.
 * `{ status:'authenticated', user:null }` → `{ status:'authenticated', user:obj }`
 * as `<AuthProvider>` resolves `getUser()` after mount. Loaders/guards read only
 * `auth.isLoggedIn()` (never the user object), so that hydration event must NOT
 * trigger a `router.invalidate()` — doing so re-runs every loader and remounts
 * the page, double-firing data calls and flickering the UI.
 */
export function isLoginStatusChange(event: AuthChangedEvent): boolean {
	return event.previousState?.status !== event.state.status;
}

/**
 * A genuine sign-out: `authenticated → anonymous` (e.g. a 401 the interceptor
 * handled). Used to notify the native webview shell. A `resolving → anonymous`
 * settle is NOT a sign-out (the user was never authenticated in this session).
 */
export function isSignOut(event: AuthChangedEvent): boolean {
	return (
		event.previousState?.status === 'authenticated' &&
		event.state.status === 'anonymous'
	);
}
